import videojs from 'video.js';

const Component = videojs.getComponent('Component');

export default class BlurVideoBackground extends Component {
  constructor(player, options) {
    super(player, options);
    player.on('ready', () => {
      const _this = this;
      this.isPlayerSeeking = false;
      this.techEl = player.tech('').el();
      this.canvasEl = this.el().querySelector('canvas');
      this.context = this.canvasEl.getContext('2d');
      this.init(player);
      player.on('play', function handlePlay() {
        if (!_this.isPlayerSeeking) {
          _this.drawImage(_this.techEl);
        }
        if (!player.paused()) {
          window.requestAnimationFrame(handlePlay);
        }
      });
      player.on('seeking', () => {
        this.isPlayerSeeking = true;
      });
      player.on('seeked', () => {
        this.isPlayerSeeking = false;
      })
    });
  }

  init(player) {
    const posterImage = player.getChild('PosterImage');
    if (!posterImage.hasClass('vjs-hidden')) {
      const imageUrl = getComputedStyle(posterImage.el()).backgroundImage.replace(/url\("|"\)/g, '');
      if (imageUrl) {
        const imageEl = new Image();
        imageEl.onload = () => {
          this.drawImage(imageEl);
          posterImage.addClass('vjs-poster_bg-transparent');
        }
        imageEl.src = imageUrl;
      }
    } else {
      player.on('canplay', () => {
        this.drawImage(this.techEl);
      });
    }
  }

  drawImage(source) {
    this.context.clearRect(0, 0, this.canvasEl.width, this.canvasEl.height);
    this.context.drawImage(source, 0, 0, this.canvasEl.width, this.canvasEl.height);
  }

  createEl() {
    let wrapper = videojs.dom.createEl('div', {
      className: 'vjs-blur-background__wrapper',
    });
    wrapper.append(videojs.dom.createEl('canvas', {
      className: 'vjs-blur-background__canvas',
    }));
    return wrapper;
  }
}

Component.registerComponent('BlurVideoBackground', BlurVideoBackground);
